// extracted by mini-css-extract-plugin
export default {"Container":"NewsBox_Container__R+xSb"};